import React, { useEffect, useState, useRef } from 'react';
import { Card, Icons } from '@curves/ui-base';
import { Dialog, DialogContent, Slide, Typography } from '@mui/material';
import { GradientColorHeader } from '@Local/Components/Dialog/';
import { isEmpty } from '@Util/utils';
import { PointsRedeemRecordTable } from '@Local/Points/Redeem';
import { initBookmark } from '@Local/Points/staticData';
import usePointsRewardsApi from '@Apis/usePointsRewardsApi';

const Transition = React.forwardRef((props, ref) => {
    return <Slide direction="up" ref={ref} {...props} />;
});
const PointsRedeemRecordDialog = React.forwardRef((props, ref) => {
    const { open: openProps = false, onClose: onCloseProps, sourceData: memberData = {} } = props;
    if (isEmpty(memberData) || !openProps) return null;
    const { getPointsRewardsRecordApi } = usePointsRewardsApi();
    const [sourceData, setSourceData] = useState([]);
    const [pageModel, setPageModel] = useState({ ...initBookmark() });
    const [combineReward, setCombineReward] = useState(null);
    const { memberNo, displayName, totalPoints, currentPoints } = memberData;
    const preloadRef = useRef(false);
    const handlePageChange = (num) => {
        setPageModel((prev) => ({ ...prev, pageIndex: num }));
    };
    const handleCombineRewardChange = (combineRewardID, displayNote) => {
        setCombineReward({ combineRewardID, displayNote });
        setPageModel({ ...initBookmark() });
    }
    const handleCloseCombine = () => {
        setCombineReward(null);
        setPageModel({ ...initBookmark() });
    }
    const getRedeemRecordApi = async (rewardID) => {
        const resp = await getPointsRewardsRecordApi(pageModel, rewardID);
        if (resp) {
            let data = { ...resp, rewardID };
            setSourceData(data);
            preloadRef.current = true;
        }
    };
    useEffect(
        () => {
            if (preloadRef.current) {
                if (combineReward) {
                    getRedeemRecordApi(combineReward.combineRewardID);
                } else {
                    getRedeemRecordApi(memberData.rewardID);
                }
            }
        },
        // eslint-disable-next-line
        [combineReward, pageModel]
    );
    useEffect(
        () => {
            if (isEmpty(sourceData)) {
                getRedeemRecordApi(memberData.rewardID);
            }
        },
        // eslint-disable-next-line
        []
    );
    return (
        <Dialog open={openProps} TransitionComponent={Transition} fullScreen>
            <GradientColorHeader onClose={onCloseProps}>累兌點紀錄</GradientColorHeader>
            <DialogContent>
                <Typography className="font-weight-bold" variant="h4">{`${memberNo} ${displayName} 累積點數：${totalPoints} | 目前點數：${currentPoints}`}</Typography>
                {!!combineReward && 
                    <Typography className="font-weight-bold typography-text-main" component="span" variant="h4">
                        {combineReward.displayNote} <Icons.Cancel onClick={handleCloseCombine} htmlColor={'#937312'} />
                    </Typography>
                }
                <Card>
                    <Card.CardContent className={'p-4'}>
                        <PointsRedeemRecordTable sourceData={sourceData}
                                                 onPageChange={handlePageChange}
                                                 onCombineRewardChange={handleCombineRewardChange}
                                                 {...pageModel} />
                    </Card.CardContent>
                </Card>
            </DialogContent>
        </Dialog>
    );
});
export default PointsRedeemRecordDialog;
